import PropTypes from "prop-types";
import { useState } from "react";
import { useVerificationDetails } from "../../context/verification-details";
import {
  verificationCustomerStatus,
  verificationFormStatus,
} from "../../constants/verification-status";
import { VerificationIFrame } from "./verification-iframe";
import styles from "./styles";
import { ErrorPageContainer } from "../error";
import VerificationForm from "./verification-form";

export default function VerifyStudentContainer({
  orgSearchUrl,
  sheerIdProgramId,
  successRedirectPath,
  countriesData,
  assetsUrl,
  displayVerificationErrorPage,
  customerStatus,
  availableCountries,
  minDateOfBirth,
  minGraduationYear,
  externalCustomerVerificationUrl,
  sheerIdLocale,
}) {
  const [errorPageType, setErrorPageType] = useState();

  const [state] = useVerificationDetails();
  const { formStatus } = state.verificationDetails;

  if (errorPageType) {
    return (
      <div className={`${styles.container} app_leavesden2`}>
        <ErrorPageContainer
          errorType={errorPageType}
          sheerIdProgramId={sheerIdProgramId}
          sheerIdLocale={sheerIdLocale}
        />
      </div>
    );
  }

  return (
    <div className={`${styles.container} app_leavesden2`}>
      {formStatus === verificationFormStatus.PENDING ||
      customerStatus === verificationCustomerStatus.PENDING_VERIFICATION ? (
        <VerificationIFrame
          customerStatus={customerStatus}
          externalCustomerVerificationUrl={externalCustomerVerificationUrl}
          sheerIdLocale={sheerIdLocale}
        />
      ) : (
        <VerificationForm
          customerStatus={customerStatus}
          orgSearchUrl={orgSearchUrl}
          sheerIdProgramId={sheerIdProgramId}
          successRedirectPath={successRedirectPath}
          countriesData={countriesData}
          availableCountries={availableCountries}
          minDateOfBirth={minDateOfBirth}
          minGraduationYear={minGraduationYear}
          assetsUrl={assetsUrl}
          displayVerificationErrorPage={displayVerificationErrorPage}
          sheerIdLocale={sheerIdLocale}
          setErrorPageType={setErrorPageType}
        />
      )}
    </div>
  );
}

VerifyStudentContainer.propTypes = {
  orgSearchUrl: PropTypes.string.isRequired,
  sheerIdProgramId: PropTypes.string.isRequired,
  successRedirectPath: PropTypes.string.isRequired,
  countriesData: PropTypes.array.isRequired,
  availableCountries: PropTypes.array.isRequired,
  minDateOfBirth: PropTypes.string.isRequired,
  minGraduationYear: PropTypes.string.isRequired,
  assetsUrl: PropTypes.string.isRequired,
  displayVerificationErrorPage: PropTypes.func.isRequired,
  customerStatus: PropTypes.string,
  externalCustomerVerificationUrl: PropTypes.string,
  sheerIdLocale: PropTypes.string.isRequired,
};
